import React, { useState, useRef, useEffect, useCallback } from "react";
import styles from "./AudioPlayer.module.css";
import stylesV1 from "./AudioPlayerV1.module.css";
import stylesV2 from "./AudioPlayerV2.module.css";
import { BsArrowLeftShort } from "react-icons/bs";
import { BsArrowRightShort } from "react-icons/bs";
import { FaPlay } from "react-icons/fa";
import { FaPause } from "react-icons/fa";

const AudioPlayer = ({ episode, version }) => {
    // state
    const [isPlaying, setIsPlaying] = useState();
    const [duration, setDuration] = useState('');
    const [currentTime, setCurrentTime] = useState(0);

    // refs
    const audioPlayer = useRef(); // reference our audio component
    const progessBar = useRef(); // Reference to progressBar
    const animationRef = useRef(); // refs the animation

    let stylesDif;

    switch (version) {
        case "v1":
            stylesDif = stylesV1;
            break;
        case "v2":
            stylesDif = stylesV2;
            break;
        default:
            stylesDif = stylesV1;
    }
    const whilePlaying = useCallback(() => {
        if (audioPlayer.current) {
            progessBar.current.value = audioPlayer.current.currentTime;
            changePlayerCurrenTime();
            animationRef.current = requestAnimationFrame(whilePlaying);
        }
    }, []);

    const calculateDurationTime = (secs) => {
        const splitted = secs.split(':');
        const hour = parseInt(splitted[0]) * 3600;
        const minutes = parseInt(splitted[1]) * 60;
        const seconds = parseInt(splitted[2]);
        return hour + minutes + seconds;
    };

    const calculateTime = (secs) => {
        const minutes = Math.floor(secs / 60);
        const returnedMinutes = minutes < 10 ? `0${minutes}` : `${minutes}`;
        const seconds = Math.floor(secs % 60);
        const returnedSeconds = seconds < 10 ? `0${seconds}` : `${seconds}`;
        return `${returnedMinutes}:${returnedSeconds}`;
    };

    const togglePlayPause = () => {
        const prevValue = isPlaying;
        setIsPlaying(!prevValue);
        if (prevValue) {
            audioPlayer.current.play();
            animationRef.current = requestAnimationFrame(whilePlaying);
        } else {
            audioPlayer.current.pause();
            cancelAnimationFrame(animationRef.current);
        }
    };

    const changeRange = () => {
        audioPlayer.current.currentTime = progessBar.current.value;
        changePlayerCurrenTime();
    };

    const changePlayerCurrenTime = () => {
        progessBar.current.style.setProperty('--seek-BeforeUnloadEvent.width', `${progessBar.current.value / duration * 100}%`);
        setCurrentTime(progessBar.current.value);
    };

    const backThrity = () => {
        progessBar.current.value = Number(progessBar.current.value) - 30;
        changeRange();
    };

    const forwardThrity = () => {
        progessBar.current.value = Number(progessBar.current.value) + 30;
        changeRange();
    };

    // useEffect
    useEffect(() => {
        const seconds = calculateDurationTime(episode.duration);
        setDuration(seconds); // Insert props.episode.duration
        progessBar.current.max = seconds;

        const handleLoadedMetadata = () => {
            audioPlayer.current.play();
            setIsPlaying(false);
            animationRef.current = requestAnimationFrame(whilePlaying);
        };

        const audioElement = audioPlayer.current;

        if (audioElement) {
            audioElement.addEventListener('loadedmetadata', handleLoadedMetadata);
        }

        return () => {
            if (audioElement) {
                audioElement.removeEventListener('loadedmetadata', handleLoadedMetadata);
            }
        };
    }, [episode, whilePlaying]);  // Add whilePlaying to dependencies array

    return (
        <div className={stylesDif.audioPlayerWrapper}>
            <div className={stylesDif.playWrapper}>
                <audio ref={audioPlayer} src={episode.url} preload="metadata"></audio>
                <button className={styles.forwardBackward} onClick={backThrity}><BsArrowLeftShort /> 30</button>
                <button onClick={togglePlayPause} className={styles.playPause}>
                    {isPlaying ? <FaPlay className={styles.play}/> : <FaPause/> }
                </button>
                <button className={styles.forwardBackward} onClick={forwardThrity}>30 <BsArrowRightShort /> </button>
            </div>
            <div className={stylesDif.timeWrapper}>
                {/* current time */}
                <div className={styles.currentTime}>{calculateTime(currentTime)}</div>

                {/* progress bar */}
                <div>
                    <input type="range" className={styles.progressBar} defaultValue="0" ref={progessBar} onChange={changeRange}/>
                </div>

                {/* duration */}
                <div className={stylesDif.duration}>{episode.duration}</div>
            </div>
        </div>
    );
};

export default AudioPlayer;
